"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COLORS_BUTTONS = exports.COLORS_SEMANTIC = exports.COLORS_GRAYS = exports.COLORS_NEUTRALS = exports.COLORS_BRAND = void 0;
// NOTE: If you are adding a new color variable, please add it to /common/_colors3.less
// to make sure they are in sync
// All Colors
// https://www.figma.com/file/jJD0yd6vihUIjhhnplwDkw/Zola-PD-Master-Library-v3?node-id=1305%3A21630
const COLOR_BAY_005 = '#f2f7f9';
const COLOR_BAY_015 = '#dbe7ec';
const COLOR_BAY_030 = '#b7ceda';
const COLOR_BAY_050 = '#87aec0';
const COLOR_BAY_085 = '#337495';
const COLOR_BAY_100 = '#0f5c82';
const COLOR_BLACK_005 = '#f3f3f3';
const COLOR_BLACK_015 = '#dbdbdb';
const COLOR_BLACK_030 = '#b7b7b7';
const COLOR_BLACK_050 = '#757575';
const COLOR_BLACK_075 = '#4a4a4a';
const COLOR_BLACK_100 = '#0e0e0e';
const COLOR_BLUSH_005 = '#fffeff';
const COLOR_BLUSH_015 = '#fffcfe';
const COLOR_BLUSH_030 = '#fff9fd';
const COLOR_BLUSH_050 = '#fff5fc';
const COLOR_BLUSH_085 = '#ffeef9';
const COLOR_BLUSH_100 = '#ffebf8';
const COLOR_CLOUD_005 = '#ffffff';
const COLOR_CLOUD_015 = '#fefefe';
const COLOR_CLOUD_030 = '#fdfdfd';
const COLOR_CLOUD_050 = '#fcfcfc';
const COLOR_CLOUD_085 = '#fafafa';
const COLOR_CLOUD_100 = '#f9f9f9';
const COLOR_COVE_005 = '#f7fafc';
const COLOR_COVE_015 = '#e5f1f5';
const COLOR_COVE_030 = '#cce3ec';
const COLOR_COVE_050 = '#aad0df';
const COLOR_COVE_085 = '#6fafc9';
const COLOR_COVE_100 = '#55a1bf';
const COLOR_DEEP_SEA_005 = '#f3f9f7';
const COLOR_DEEP_SEA_100 = '#15845D';
const COLOR_FOREST_005 = '#f2f7f7';
const COLOR_FOREST_015 = '#d9e6e6';
const COLOR_FOREST_030 = '#b3cdcd';
const COLOR_FOREST_050 = '#7ca7a9';
const COLOR_FOREST_085 = '#267072';
const COLOR_FOREST_100 = '#005759';
const COLOR_GRAY_100 = '#868686';
const COLOR_LILAC_005 = '#fdfcff';
const COLOR_LILAC_015 = '#f9f7ff';
const COLOR_LILAC_030 = '#f4effe';
const COLOR_LILAC_050 = '#ece4fe';
const COLOR_LILAC_085 = '#dfd2fc';
const COLOR_LILAC_100 = '#d9cafc';
const COLOR_MARINE_005 = '#f4f5f7';
const COLOR_MARINE_015 = '#dce2e5';
const COLOR_MARINE_030 = '#bac4cc';
const COLOR_MARINE_050 = '#8b9da9';
const COLOR_MARINE_085 = '#3b586e';
const COLOR_MARINE_100 = '#183b54';
const COLOR_MINT_005 = '#fdfffd';
const COLOR_MINT_015 = '#f9fef9';
const COLOR_MINT_030 = '#f3fcf4';
const COLOR_MINT_050 = '#ebfaec';
const COLOR_MINT_085 = '#ddf7df';
const COLOR_MINT_100 = '#d7f5d9';
const COLOR_ORANGE_PEEL_005 = '#fffaf2';
const COLOR_ORANGE_PEEL_100 = '#ff9a00';
const COLOR_ROSE_005 = '#fcf5f7';
const COLOR_ROSE_015 = '#f7e0e6';
const COLOR_ROSE_030 = '#eec1ce';
const COLOR_ROSE_050 = '#e398ad';
const COLOR_ROSE_085 = '#cf4f74';
const COLOR_ROSE_100 = '#c7305b';
const COLOR_SKY_005 = '#f9ffff';
const COLOR_SKY_015 = '#edfeff';
const COLOR_SKY_030 = '#dcfefe';
const COLOR_SKY_050 = '#c4fdfe';
const COLOR_SKY_085 = '#9bfbfc';
const COLOR_SKY_100 = '#89fafc';
const COLOR_WHITE_100 = '#ffffff';
const COLOR_WINE_005 = '#f8f3f5';
const COLOR_WINE_015 = '#ebdce2';
const COLOR_WINE_030 = '#d6b8c5';
const COLOR_WINE_050 = '#bb899f';
const COLOR_WINE_085 = '#8b365c';
const COLOR_WINE_100 = '#77133f'; // All approved colors for general usage
// Excludes some semantic only colors so they are used properly

const COLORS = {
  BAY_100: COLOR_BAY_100,
  BLACK_005: COLOR_BLACK_005,
  BLACK_015: COLOR_BLACK_015,
  BLACK_030: COLOR_BLACK_030,
  BLACK_050: COLOR_BLACK_050,
  BLACK_075: COLOR_BLACK_075,
  BLACK_100: COLOR_BLACK_100,
  BLUSH_100: COLOR_BLUSH_100,
  CLOUD_100: COLOR_CLOUD_100,
  COVE_100: COLOR_COVE_100,
  FOREST_100: COLOR_FOREST_100,
  GRAY_100: COLOR_GRAY_100,
  LILAC_100: COLOR_LILAC_100,
  MARINE_100: COLOR_MARINE_100,
  MINT_100: COLOR_MINT_100,
  ROSE_005: COLOR_ROSE_005,
  ROSE_030: COLOR_ROSE_030,
  ROSE_085: COLOR_ROSE_085,
  ROSE_100: COLOR_ROSE_100,
  SKY_100: COLOR_SKY_100,
  WHITE_100: COLOR_WHITE_100,
  WINE_100: COLOR_WINE_100
}; // Brand Colors
// https://www.figma.com/file/jJD0yd6vihUIjhhnplwDkw/Zola-PD-Master-Library-v3?node-id=3%3A9

const COLORS_BRAND = {
  BOLD_BAY_100: COLOR_BAY_100,
  BOLD_CLOUD_100: COLOR_CLOUD_100,
  BOLD_COVE_100: COLOR_COVE_100,
  BOLD_FOREST_100: COLOR_FOREST_100,
  BOLD_MARINE_100: COLOR_MARINE_100,
  BOLD_ROSE_100: COLOR_ROSE_100,
  BOLD_WINE_100: COLOR_WINE_100,
  SECONDARY_BLUSH_100: COLOR_BLUSH_100,
  SECONDARY_LILAC_100: COLOR_LILAC_100,
  SECONDARY_MINT_100: COLOR_MINT_100,
  SECONDARY_SKY_100: COLOR_SKY_100
}; // Neutral Colors
// https://www.figma.com/file/jJD0yd6vihUIjhhnplwDkw/Zola-PD-Master-Library-v3?node-id=52%3A539

exports.COLORS_BRAND = COLORS_BRAND;
const COLORS_NEUTRALS = {
  BLACK_100: COLOR_BLACK_100,
  GRAY_100: COLOR_GRAY_100,
  WHITE_100: COLOR_WHITE_100
}; // Gray Colors
// https://www.figma.com/file/jJD0yd6vihUIjhhnplwDkw/Zola-PD-Master-Library-v3?node-id=1305%3A21630

exports.COLORS_NEUTRALS = COLORS_NEUTRALS;
const COLORS_GRAYS = {
  BLACK_005: COLOR_BLACK_005,
  BLACK_015: COLOR_BLACK_015,
  BLACK_030: COLOR_BLACK_030,
  BLACK_050: COLOR_BLACK_050,
  BLACK_075: COLOR_BLACK_075
}; // Semantic Colors

exports.COLORS_GRAYS = COLORS_GRAYS;
const COLORS_SEMANTIC = {
  NEGATIVE_005: COLOR_ROSE_005,
  NEGATIVE_030: COLOR_ROSE_030,
  NEGATIVE_075: COLOR_ROSE_085,
  NEGATIVE_100: COLOR_ROSE_100,
  INFORMATIONAL_005: COLOR_COVE_005,
  INFORMATIONAL_100: COLOR_COVE_100,
  POSITIVE_005: COLOR_DEEP_SEA_005,
  POSITIVE_100: COLOR_DEEP_SEA_100,
  WARNING_005: COLOR_ORANGE_PEEL_005,
  WARNING_100: COLOR_ORANGE_PEEL_100
}; // Colors available for Buttons

exports.COLORS_SEMANTIC = COLORS_SEMANTIC;
const COLORS_BUTTONS = {
  BAY_005: COLOR_BAY_005,
  BAY_015: COLOR_BAY_015,
  BAY_030: COLOR_BAY_030,
  BAY_050: COLOR_BAY_050,
  BAY_085: COLOR_BAY_085,
  BAY_100: COLOR_BAY_100,
  BLACK_005: COLOR_BLACK_005,
  BLACK_015: COLOR_BLACK_015,
  BLACK_030: COLOR_BLACK_030,
  BLACK_050: COLOR_BLACK_050,
  BLACK_075: COLOR_BLACK_075,
  BLACK_100: COLOR_BLACK_100,
  BLUSH_005: COLOR_BLUSH_005,
  BLUSH_015: COLOR_BLUSH_015,
  BLUSH_030: COLOR_BLUSH_030,
  BLUSH_050: COLOR_BLUSH_050,
  BLUSH_085: COLOR_BLUSH_085,
  BLUSH_100: COLOR_BLUSH_100,
  CLOUD_005: COLOR_CLOUD_005,
  CLOUD_015: COLOR_CLOUD_015,
  CLOUD_030: COLOR_CLOUD_030,
  CLOUD_050: COLOR_CLOUD_050,
  CLOUD_085: COLOR_CLOUD_085,
  CLOUD_100: COLOR_CLOUD_100,
  COVE_005: COLOR_COVE_005,
  COVE_015: COLOR_COVE_015,
  COVE_030: COLOR_COVE_030,
  COVE_050: COLOR_COVE_050,
  COVE_085: COLOR_COVE_085,
  COVE_100: COLOR_COVE_100,
  FOREST_005: COLOR_FOREST_005,
  FOREST_015: COLOR_FOREST_015,
  FOREST_030: COLOR_FOREST_030,
  FOREST_050: COLOR_FOREST_050,
  FOREST_085: COLOR_FOREST_085,
  FOREST_100: COLOR_FOREST_100,
  LILAC_005: COLOR_LILAC_005,
  LILAC_015: COLOR_LILAC_015,
  LILAC_030: COLOR_LILAC_030,
  LILAC_050: COLOR_LILAC_050,
  LILAC_085: COLOR_LILAC_085,
  LILAC_100: COLOR_LILAC_100,
  MARINE_005: COLOR_MARINE_005,
  MARINE_015: COLOR_MARINE_015,
  MARINE_030: COLOR_MARINE_030,
  MARINE_050: COLOR_MARINE_050,
  MARINE_085: COLOR_MARINE_085,
  MARINE_100: COLOR_MARINE_100,
  MINT_005: COLOR_MINT_005,
  MINT_015: COLOR_MINT_015,
  MINT_030: COLOR_MINT_030,
  MINT_050: COLOR_MINT_050,
  MINT_085: COLOR_MINT_085,
  MINT_100: COLOR_MINT_100,
  ROSE_005: COLOR_ROSE_005,
  ROSE_015: COLOR_ROSE_015,
  ROSE_030: COLOR_ROSE_030,
  ROSE_085: COLOR_ROSE_085,
  ROSE_050: COLOR_ROSE_050,
  ROSE_100: COLOR_ROSE_100,
  SKY_005: COLOR_SKY_005,
  SKY_015: COLOR_SKY_015,
  SKY_030: COLOR_SKY_030,
  SKY_050: COLOR_SKY_050,
  SKY_085: COLOR_SKY_085,
  SKY_100: COLOR_SKY_100,
  WHITE_100: COLOR_WHITE_100,
  WINE_005: COLOR_WINE_005,
  WINE_015: COLOR_WINE_015,
  WINE_030: COLOR_WINE_030,
  WINE_050: COLOR_WINE_050,
  WINE_085: COLOR_WINE_085,
  WINE_100: COLOR_WINE_100
};
exports.COLORS_BUTTONS = COLORS_BUTTONS;
var _default = COLORS;
exports.default = _default;